import React from 'react';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
import Toolbar from './Toolbar';

interface MainLayoutProps {
    children: React.ReactNode;
    showToolBar?: boolean;
    /**
     * Use the full desktop width instead of the phone-width column. The app is
     * PWA-first (ADR-0009) and every screen is a `max-w-md` column; the room
     * week view (#3036) is the one desktop-first screen, where seven days of
     * three hall segments cannot fit a phone column.
     */
    wide?: boolean;
}

const MainLayout = (props: MainLayoutProps) => {
    const { t } = useTranslation();
    const contentHeight = props.showToolBar ? 'calc(100% - 59px)' : '100%';
    return (
        <Box sx={{ height: '100%' }}>
            <a
                href="#main-content"
                className="sr-only focus:not-sr-only focus:absolute focus:left-2 focus:top-2 focus:z-[1000] focus:rounded focus:bg-background focus:px-3 focus:py-2 focus:text-foreground focus:ring-2 focus:ring-primary"
            >
                {t('common.skip_to_content')}
            </a>
            <Box component="main" id="main-content" className={props.wide ? 'max-w-7xl mx-auto' : 'max-w-md mx-auto'}
                sx={{
                    height: contentHeight,
                    overflowY: 'auto',
                    overflowX: 'hidden',
                }}
            >
                {props.children}
            </Box>
            <div className='fixed inset-x-0 bottom-0'>
                {props.showToolBar && <Toolbar />}
            </div>
        </Box>
    );
};

export default MainLayout;
